import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1f09ff80"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "" };
const _hoisted_2 = { class: "content" };
const _hoisted_3 = {
    key: 1,
    class: "input"
};
const _hoisted_4 = {
    key: 0,
    class: ""
};
const _hoisted_5 = {
    key: 1,
    class: "market"
};
const _hoisted_6 = {
    key: 2,
    class: "flex"
};
const _hoisted_7 = {
    key: 1,
    class: "open sm-account"
};
import TradeButton from '@/materials/molecules/TradeButton.vue';
import OrderMarket from '@/components/organisms/main/trade/order/OrderMarket.vue';
import { useStore } from '@/store/store';
import { useOrder, useOrderDisplay } from '@/logics/order';
import { inject, watchEffect } from 'vue';
import Button from '@/materials/atoms/Button.vue';
import OrderTradeType from '@/components/organisms/main/trade/order/OrderTradeType.vue';
import OrderPriceWithBalance from '@/components/organisms/main/trade/order/OrderPriceWithBalance.vue';
import RangeBarWithClear from '@/materials/molecules/RangeBarWithClear.vue';
import OrderConfirm from '@/components/organisms/modal/OrderConfirm.vue';
import Loading from '@/materials/molecules/Loading.vue';
import { useSettings } from '@/logics/settings';
import { useMessage } from '@/const/messages';
import RefreshWarn from '@/materials/atoms/RefreshWarn.vue';
import { useSound } from '@/logics/sound';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        pair: null,
        base: null,
        quote: null,
        isAuth: { type: Boolean },
        latestValue: null,
        trade: { default: 'Buy' }
    },
    emits: ["click"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const store = useStore();
        const toast = inject('toast');
        const { putUserSettings } = useSettings();
        const { orderSuccessLow, orderSuccessMiddle, orderSuccessHigh, orderFailed, play } = useSound();
        const { format, ORDER, ORDER_MESSAGES } = useMessage();
        const { postOrder, validate, isFairPrice, isLoading } = useOrder();
        const { 
        /** Functions */
        onClickTradeType, marketModeChange, onChangeDeal, onChangeRange, showConfirm, modalClose, setColorMode, setButtonText, 
        /** Consts */
        quoteStep, baseStep, limitPriceStep, 
        /** Status */
        tradeType, orderType, isShowConfirm, marketMode, } = useOrderDisplay(props.quote, props.base, props.pair, store.state.currencyInfo, store.state.currencyPairInfo);
        const base1 = Number(process.env.VUE_APP_SOUND_BASE_1);
        const base2 = Number(process.env.VUE_APP_SOUND_BASE_2);
        watchEffect(() => {
            store.state.order.price = props.latestValue;
        });
        // 注文メイン処理
        const onOrder = (isChecked) => __awaiter(this, void 0, void 0, function* () {
            try {
                modalClose();
                const isLimit = tradeType.value === 'Limit';
                const isSell = orderType.value === 'Sell';
                const isMarketMode = marketMode.value === 'Amount';
                const message = validate(Number(store.state.order.price), Number(store.state.order.amount), isLimit, isSell, store.state.balances, props.base, props.quote, isMarketMode, store.state.latestValue, props.pair, store.state.currencyPairInfo);
                if (message) {
                    toast.error(format(message));
                    play(orderFailed);
                    return;
                }
                if (!isFairPrice(store.state.order.price, store.state.latestValue, tradeType.value === 'Market')) {
                    if (!confirm(format(ORDER_MESSAGES.NOT_FAIR_PRICE))) {
                        return;
                    }
                }
                yield postOrder(store.state.symbol.pair, Number(store.state.order.price), Number(store.state.order.amount), orderType.value, tradeType.value, isMarketMode);
                if (isChecked) {
                    store.state.userSettings.isOrderLeave = isChecked;
                    putUserSettings({
                        isOrderLeave: isChecked,
                    });
                }
                toast.success(format(ORDER_MESSAGES.SUCCESS));
                // Todo: 基準を決める
                const total = Number(store.state.order.price) * Number(store.state.order.amount);
                if (total >= base2) {
                    play(orderSuccessHigh);
                }
                else if (base1 < total && total < base2) {
                    play(orderSuccessMiddle);
                }
                else {
                    play(orderSuccessLow);
                }
                store.commit('countUpOder');
            }
            catch (err) {
                const data = err.response.data;
                const message = err.trace
                    ? format(ORDER_MESSAGES.ORDER_FAILED)
                    : `${data.message}\r\n errorCode: ${data.errorCode}`;
                toast.error(message);
                play(orderFailed);
            }
        });
        const openAccount = () => {
            window.open('https://www.bigboss-financial.com/account/qopen', '_blank');
        };
        onChangeDeal(props.trade);
        const clickClose = () => {
            emits('click', false);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(isShowConfirm))
                    ? (_openBlock(), _createBlock(OrderConfirm, {
                        key: 0,
                        base: props.base,
                        quote: props.quote,
                        "order-type": _unref(orderType),
                        "trade-type": _unref(tradeType),
                        price: _unref(store).state.order.price,
                        amount: _unref(store).state.order.amount,
                        "market-mode": _unref(marketMode),
                        onOrder: onOrder,
                        onCancel: _unref(modalClose)
                    }, null, 8, ["base", "quote", "order-type", "trade-type", "price", "amount", "market-mode", "onCancel"]))
                    : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", {
                    class: "close_btn",
                    onClick: clickClose
                }, [
                    _createVNode(MaterialIcon, { name: "close" })
                ], 512), [
                    [_vShow, _unref(store).state.isSmartPhone]
                ]),
                _createVNode(TradeButton, {
                    class: "trade_button",
                    trade: _unref(orderType),
                    onClick: _unref(onChangeDeal)
                }, null, 8, ["trade", "onClick"]),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(OrderTradeType, {
                        class: "trade_type",
                        onClick: _unref(onClickTradeType)
                    }, null, 8, ["onClick"]),
                    (_unref(store).state.currencyPairInfo.length === 0)
                        ? (_openBlock(), _createBlock(RefreshWarn, {
                            key: 0,
                            class: "warn"
                        }))
                        : _createCommentVNode("", true),
                    (_unref(store).state.currencyPairInfo.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_unref(tradeType) === 'Limit')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createVNode(OrderPriceWithBalance, {
                                        class: "price-text",
                                        mode: "Price",
                                        title: _unref(format)(_unref(ORDER).PRICE),
                                        symbol: props.quote,
                                        step: _unref(limitPriceStep),
                                        "trade-type": _unref(tradeType)
                                    }, null, 8, ["title", "symbol", "step", "trade-type"]),
                                    _createVNode(OrderPriceWithBalance, {
                                        class: "price-text",
                                        mode: "Amount",
                                        title: _unref(format)(_unref(ORDER).AMOUNT),
                                        symbol: props.base,
                                        step: _unref(baseStep),
                                        "trade-type": _unref(tradeType)
                                    }, null, 8, ["title", "symbol", "step", "trade-type"])
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(tradeType) === 'Market')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    (_openBlock(), _createBlock(OrderMarket, {
                                        key: _unref(marketMode),
                                        symbol: _unref(marketMode) === 'Price' ? props.quote : props.base,
                                        step: _unref(marketMode) === 'Price' ? _unref(quoteStep) : _unref(baseStep),
                                        mode: _unref(marketMode),
                                        "is-sell": _unref(orderType) === 'Sell',
                                        onSelectionChange: _unref(marketModeChange)
                                    }, null, 8, ["symbol", "step", "mode", "is-sell", "onSelectionChange"]))
                                ]))
                                : _createCommentVNode("", true),
                            _createVNode(RangeBarWithClear, {
                                class: "rangebar",
                                base: props.base,
                                onClick: _unref(onChangeRange)
                            }, null, 8, ["base", "onClick"]),
                            (!_unref(store).state.isSmartPhone || props.isAuth)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (!_unref(isLoading) && !props.isAuth)
                                        ? (_openBlock(), _createBlock(Button, {
                                            key: 0,
                                            width: "250px",
                                            height: "35px",
                                            class: _normalizeClass(["button pd open_account", !props.isAuth ? 'overlay_z' : '']),
                                            "inner-text": _unref(format)(_unref(ORDER).OPEN_ACCOUNT),
                                            "color-mode": _unref(setColorMode)(props.isAuth),
                                            onClick: openAccount
                                        }, null, 8, ["inner-text", "color-mode", "class"]))
                                        : _createCommentVNode("", true),
                                    (!_unref(isLoading))
                                        ? (_openBlock(), _createBlock(Button, {
                                            key: 1,
                                            width: "250px",
                                            height: "35px",
                                            class: _normalizeClass(["button", !props.isAuth ? 'overlay_z' : '']),
                                            "inner-text": _unref(setButtonText)(props.isAuth),
                                            "color-mode": _unref(setColorMode)(props.isAuth),
                                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(showConfirm)(props.isAuth, onOrder)))
                                        }, null, 8, ["inner-text", "color-mode", "class"]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(isLoading))
                                ? (_openBlock(), _createBlock(Loading, {
                                    key: 3,
                                    mode: "simple"
                                }))
                                : _createCommentVNode("", true),
                            (props.isAuth)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 4,
                                    class: _normalizeClass(!_unref(isLoading) ? 'order_text' : 'loading_order_text')
                                }, _toDisplayString(_unref(format)(_unref(ORDER).ONE_CLICK)) + " : " + _toDisplayString(_unref(store).state.userSettings.isOrderLeave ? 'ON' : 'OFF'), 3))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                (_unref(store).state.isSmartPhone && !props.isAuth)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (!_unref(isLoading))
                            ? (_openBlock(), _createBlock(Button, {
                                key: 0,
                                width: "170px",
                                height: "50px",
                                class: _normalizeClass(["button pd open_account", !props.isAuth ? 'overlay_z' : '']),
                                "inner-text": _unref(format)(_unref(ORDER).OPEN_ACCOUNT),
                                "color-mode": _unref(setColorMode)(props.isAuth),
                                onClick: openAccount
                            }, null, 8, ["inner-text", "color-mode", "class"]))
                            : _createCommentVNode("", true),
                        (!_unref(isLoading))
                            ? (_openBlock(), _createBlock(Button, {
                                key: 1,
                                width: "170px",
                                height: "50px",
                                class: _normalizeClass(["button", !props.isAuth ? 'overlay_z' : '']),
                                "inner-text": _unref(setButtonText)(props.isAuth),
                                "color-mode": _unref(setColorMode)(props.isAuth),
                                onClick: _cache[1] || (_cache[1] = ($event) => (_unref(showConfirm)(props.isAuth, onOrder)))
                            }, null, 8, ["inner-text", "color-mode", "class"]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
